export enum CacheKeys {
    OnlineVisibleMerchants = 'app-online-visible-merchants-${0}-${1},${2}',
    MerchantMenu = 'merchant-menu-${0}-${1}',
    OrderPreview = 'order-preview-${0}-${1}-${2}',
    CostCentreGeoCode = 'cost-centre:geocode:${0}'
}